import React, { ReactNode } from "react";
import { Modal } from "antd";

import styles from "./MegaohoneModal.module.scss";
import { IconType } from "react-icons";
import classNames from "classnames";
import { AiOutlineClose } from "react-icons/ai";

interface MegaphoneModalProps {
  width?: number | string;
  children: ReactNode;
  icon?: string | IconType | null;
  title: string;
  visible: boolean;
  onClose: () => void;
  modalKey: string;
  footer?: ReactNode;
  customClassNames?: {
    header?: string;
    body?: string;
  };
  closable?: boolean;
  headerRight?: ReactNode;
}

const MegaphoneModal: React.FC<MegaphoneModalProps> = ({
  title,
  width = 300,
  children,
  icon,
  visible,
  onClose,
  modalKey,
  footer,
  customClassNames = {},
  closable = false,
  headerRight,
}) => {
  const IconComponent = icon && typeof icon !== "string" ? icon : null;
  const headerClassName = classNames(styles.header, customClassNames.header);
  const bodyClassName = classNames(styles.body, customClassNames.body);

  return (
    <Modal
      key={modalKey}
      className={"customModal"}
      onCancel={onClose}
      closeIcon={<AiOutlineClose color={"#ffffff"} />}
      closable={closable}
      maskClosable={closable}
      title={
        <div className={styles.headerWrapper}>
          <div className={headerClassName}>
            <span className={styles.modalIcon}>
              <div className={styles.iconWrapper}>
                {icon && IconComponent ? (
                  <IconComponent color={"#ff6347"} size={24} />
                ) : (
                  <img src={icon as string} alt={title} className={styles.image} />
                )}
              </div>
            </span>
            {title}
          </div>
          <div
            className={`${styles.headerRight} ${closable ? "me-5" : "me-1"}`}
          >
            {headerRight}
          </div>
        </div>
      }
      open={visible}
      footer={footer}
      width={width}
    >
      <div className={bodyClassName}>{children}</div>
    </Modal>
  );
};

export default MegaphoneModal;
